import { RefObject, useMemo } from 'react';
import { useMilestonesTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setMilestoneMetric } from '../../../../../store/strategy-store/strategy-store.actions';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { hasArrayData } from '../../initiative-performance.helpers';
import { useChartData } from './milestone-progress-chart/milestone-progress-chart.hooks';

type Props = {
  chartRef: RefObject<HTMLDivElement>;
};

export const MainSectionHeader = ({ chartRef }: Props) => {
  const metric = useMilestonesTabStore((state) => state.metric);
  const selectedMilestone = useMilestonesTabStore((state) => state.selectedMilestone);

  const chartData = useChartData(metric);
  const hasData = useMemo(() => hasArrayData(chartData) && selectedMilestone !== null, [chartData, selectedMilestone]);

  // Flora support can be added in the future
  // const floraData = useMemo(() => {
  //   return formatMilestoneProgressDataForFlora(chartData, metric);
  // }, [chartData, metric]);

  return (
    <MainSectionControls
      title={'Progress'}
      chartRef={chartRef}
      metric={metric}
      setMetric={setMilestoneMetric}
      disableControls={!hasData}
    />
  );
};
